export interface HireItem {
  id: string;
  name: string;
  category: string;
  price: number;
  unit: string;
  minQty: number;
  maxQty?: number;
  image: string;
  promo?: boolean;
  description?: string;
}

export const hireCategories = [
  'All',
  'Portable Bars',
  'Bar Mats & Accessories',
  'Acrylic Glassware',
  'Consumables',
  'Staffing',
  'Furniture',
  'Glassware',
  'Tableware',
  'Lighting & AV',
  'Decor',
];

export const hireEquipment: HireItem[] = [
  {
    id: 'pb-001',
    name: 'Classic Timber Portable Bar',
    category: 'Portable Bars',
    price: 350,
    unit: 'per day',
    minQty: 1,
    image: 'https://public.readdy.ai/ai/img_res/4e8f11709d9984affdfc722ab20a68ee.jpg',
  },
  {
    id: 'pb-002',
    name: 'LED Illuminated Bar',
    category: 'Portable Bars',
    price: 450,
    unit: 'per day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20illuminated%20portable%20bar%20counter%20glowing%20warm%20white%20light%20on%20clean%20white%20background%2C%20premium%20mobile%20cocktail%20bar%20for%20events%2C%20professional%20product%20photography%2C%20sleek%20contemporary%20design&width=400&height=400&seq=hire-pbar-002&orientation=squarish',
  },
  {
    id: 'pb-003',
    name: 'Rustic Barrel Bar Station',
    category: 'Portable Bars',
    price: 280,
    unit: 'per day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=rustic%20wine%20barrel%20converted%20into%20portable%20bar%20station%20on%20clean%20white%20background%2C%20vintage%20event%20bar%2C%20reclaimed%20wood%20barrel%20bar%2C%20professional%20product%20photography%2C%20warm%20tones&width=400&height=400&seq=hire-pbar-003&orientation=squarish',
  },
  {
    id: 'pb-004',
    name: 'Gold Frame Portable Bar',
    category: 'Portable Bars',
    price: 520,
    unit: 'per day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=luxurious%20gold%20metal%20frame%20portable%20bar%20with%20marble%20top%20on%20clean%20white%20background%2C%20premium%20event%20bar%20counter%2C%20elegant%20cocktail%20station%2C%20professional%20product%20photography%2C%20glamorous%20design&width=400&height=400&seq=hire-pbar-004&orientation=squarish',
  },
  {
    id: 'pb-005',
    name: 'Compact Pop-Up Bar',
    category: 'Portable Bars',
    price: 180,
    unit: 'per day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=compact%20foldable%20pop%20up%20bar%20counter%20in%20black%20finish%20on%20clean%20white%20background%2C%20portable%20event%20bar%20station%2C%20lightweight%20mobile%20bar%2C%20professional%20product%20photography%2C%20modern%20minimalist%20design&width=400&height=400&seq=hire-pbar-005&orientation=squarish',
  },
  {
    id: 'pb-006',
    name: 'Portable Bar Ice Cooler',
    category: 'Portable Bars',
    price: 65,
    unit: 'per day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=portable%20bar%20ice%20cooler%20insulated%20stainless%20steel%20tub%20with%20drain%20on%20clean%20white%20background%2C%20premium%20event%20ice%20bucket%20cooler%20for%20drinks%20and%20bottles%2C%20professional%20product%20photography%2C%20sleek%20modern%20design%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-pbar-006&orientation=squarish',
  },
  {
    id: 'bm-001',
    name: 'Premium Rubber Bar Mat',
    category: 'Bar Mats & Accessories',
    price: 8,
    unit: 'per mat/day',
    minQty: 5,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20rubber%20bar%20service%20mat%20with%20drainage%20holes%20on%20clean%20white%20background%2C%20professional%20bartender%20bar%20mat%2C%20non-slip%20surface%2C%20product%20photography%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-bmat-001&orientation=squarish',
  },
  {
    id: 'bm-002',
    name: 'Custom Branded Bar Runner',
    category: 'Bar Mats & Accessories',
    price: 15,
    unit: 'per runner/day',
    minQty: 3,
    image: 'https://readdy.ai/api/search-image?query=elegant%20custom%20branded%20bar%20runner%20mat%20in%20black%20with%20gold%20trim%20on%20clean%20white%20background%2C%20premium%20bar%20counter%20runner%2C%20professional%20bartending%20accessory%2C%20product%20photography&width=400&height=400&seq=hire-bmat-002&orientation=squarish',
  },
  {
    id: 'bm-003',
    name: 'Silicone Drip Mat Set',
    category: 'Bar Mats & Accessories',
    price: 6,
    unit: 'per set/day',
    minQty: 10,
    image: 'https://readdy.ai/api/search-image?query=set%20of%20silicone%20drip%20mats%20for%20cocktail%20bar%20in%20dark%20grey%20on%20clean%20white%20background%2C%20professional%20bar%20accessories%2C%20drink%20coaster%20mats%2C%20product%20photography%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-bmat-003&orientation=squarish',
  },
  {
    id: 'bm-004',
    name: 'Bar Caddy Organiser',
    category: 'Bar Mats & Accessories',
    price: 12,
    unit: 'per unit/day',
    minQty: 2,
    image: 'https://readdy.ai/api/search-image?query=professional%20bar%20caddy%20napkin%20and%20straw%20organiser%20in%20black%20on%20clean%20white%20background%2C%20bartender%20station%20organiser%2C%20cocktail%20bar%20accessory%2C%20product%20photography%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-bmat-004&orientation=squarish',
  },
  {
    id: 'bm-005',
    name: 'Ice Well Bar Mat',
    category: 'Bar Mats & Accessories',
    price: 18,
    unit: 'per unit/day',
    minQty: 2,
    image: 'https://readdy.ai/api/search-image?query=professional%20ice%20well%20insert%20with%20surrounding%20rubber%20bar%20mat%20on%20clean%20white%20background%2C%20bartender%20ice%20station%2C%20cocktail%20bar%20equipment%2C%20product%20photography%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-bmat-005&orientation=squarish',
  },
  {
    id: 'fur-001',
    name: 'Chiavari Gold Chairs',
    category: 'Furniture',
    price: 12,
    unit: 'per chair/day',
    minQty: 20,
    image: 'https://readdy.ai/api/search-image?query=elegant%20gold%20chiavari%20chair%20with%20white%20cushion%20on%20clean%20white%20background%2C%20premium%20event%20furniture%20rental%2C%20professional%20product%20photography%2C%20luxury%20wedding%20chair%2C%20simple%20clean%20studio%20lighting&width=400&height=400&seq=hire-chair-001&orientation=squarish',
  },
  {
    id: 'fur-002',
    name: 'Round Banquet Tables',
    category: 'Furniture',
    price: 45,
    unit: 'per table/day',
    minQty: 5,
    image: 'https://readdy.ai/api/search-image?query=elegant%20round%20banquet%20table%20with%20white%20linen%20tablecloth%20on%20clean%20white%20background%2C%20premium%20event%20furniture%20rental%2C%20professional%20product%20photography%20luxury%20dining%20table%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-table-001&orientation=squarish',
  },
  {
    id: 'fur-003',
    name: 'Velvet Lounge Sofa',
    category: 'Furniture',
    price: 120,
    unit: 'per piece/day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=elegant%20emerald%20green%20velvet%20lounge%20sofa%20on%20clean%20white%20background%2C%20premium%20event%20furniture%20rental%20luxury%20seating%20professional%20product%20photography%20simple%20studio%20lighting&width=400&height=400&seq=hire-sofa-001&orientation=squarish',
  },
  {
    id: 'fur-004',
    name: 'High Bar Stools',
    category: 'Furniture',
    price: 18,
    unit: 'per stool/day',
    minQty: 10,
    image: 'https://readdy.ai/api/search-image?query=modern%20high%20bar%20stool%20with%20gold%20metal%20legs%20and%20black%20cushion%20on%20clean%20white%20background%2C%20premium%20event%20furniture%20rental%2C%20cocktail%20bar%20seating%2C%20professional%20product%20photography&width=400&height=400&seq=hire-stool-001&orientation=squarish',
  },
  {
    id: 'gls-001',
    name: 'Crystal Wine Glasses',
    category: 'Glassware',
    price: 4,
    unit: 'per glass/day',
    minQty: 50,
    image: 'https://readdy.ai/api/search-image?query=premium%20crystal%20wine%20glass%20on%20clean%20white%20background%2C%20elegant%20stemware%2C%20professional%20product%20photography%2C%20luxury%20event%20glassware%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-wine-001&orientation=squarish',
  },
  {
    id: 'gls-002',
    name: 'Champagne Flutes',
    category: 'Glassware',
    price: 4,
    unit: 'per flute/day',
    minQty: 50,
    image: 'https://readdy.ai/api/search-image?query=elegant%20champagne%20flute%20glass%20on%20clean%20white%20background%2C%20premium%20sparkling%20wine%20glass%2C%20professional%20product%20photography%2C%20luxury%20event%20glassware%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-flute-001&orientation=squarish',
  },
  {
    id: 'gls-003',
    name: 'Cocktail Coupe Glasses',
    category: 'Glassware',
    price: 5,
    unit: 'per glass/day',
    minQty: 30,
    image: 'https://readdy.ai/api/search-image?query=vintage%20cocktail%20coupe%20glass%20on%20clean%20white%20background%2C%20elegant%20art%20deco%20style%20stemware%2C%20professional%20product%20photography%2C%20luxury%20event%20glassware%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-coupe-001&orientation=squarish',
  },
  {
    id: 'tab-001',
    name: 'Gold Cutlery Collection',
    category: 'Tableware',
    price: 4,
    unit: 'per setting/day',
    minQty: 50,
    image: 'https://readdy.ai/api/search-image?query=premium%20gold%20cutlery%20set%20with%20knife%20fork%20spoon%20on%20clean%20white%20background%2C%20elegant%20event%20tableware%20rental%2C%20professional%20product%20photography%20luxury%20dining%20flatware%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-cutlery-001&orientation=squarish',
  },
  {
    id: 'tab-002',
    name: 'Charger Plates Gold',
    category: 'Tableware',
    price: 6,
    unit: 'per plate/day',
    minQty: 30,
    image: 'https://readdy.ai/api/search-image?query=elegant%20gold%20charger%20plate%20on%20clean%20white%20background%2C%20premium%20event%20tableware%2C%20decorative%20dinner%20plate%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-charger-001&orientation=squarish',
  },
  {
    id: 'lit-001',
    name: 'LED Uplighting Package',
    category: 'Lighting & AV',
    price: 250,
    unit: 'per event',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=professional%20LED%20uplighting%20equipment%20for%20events%2C%20warm%20amber%20and%20white%20LED%20lights%20on%20clean%20white%20background%2C%20event%20lighting%20rental%20equipment%2C%20professional%20product%20photography%20simple%20studio%20lighting&width=400&height=400&seq=hire-light-001&orientation=squarish',
  },
  {
    id: 'lit-002',
    name: 'Festoon String Lights',
    category: 'Lighting & AV',
    price: 85,
    unit: 'per 20m strand',
    minQty: 3,
    image: 'https://readdy.ai/api/search-image?query=warm%20festoon%20string%20lights%20bulbs%20coiled%20on%20clean%20white%20background%2C%20outdoor%20event%20lighting%2C%20vintage%20Edison%20bulb%20string%20lights%2C%20professional%20product%20photography%20simple%20studio%20lighting&width=400&height=400&seq=hire-festoon-001&orientation=squarish',
  },
  {
    id: 'lit-003',
    name: 'PA Sound System',
    category: 'Lighting & AV',
    price: 350,
    unit: 'per event',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=professional%20PA%20speaker%20system%20and%20microphone%20on%20clean%20white%20background%2C%20event%20audio%20equipment%20rental%20professional%20sound%20system%20product%20photography%20simple%20studio%20lighting&width=400&height=400&seq=hire-sound-001&orientation=squarish',
  },
  {
    id: 'dec-001',
    name: 'Floral Arch Frame',
    category: 'Decor',
    price: 180,
    unit: 'per event',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=elegant%20gold%20metal%20wedding%20arch%20frame%20on%20clean%20white%20background%2C%20ceremony%20backdrop%20structure%2C%20premium%20event%20decor%20rental%20professional%20product%20photography%20simple%20studio%20lighting&width=400&height=400&seq=hire-arch-001&orientation=squarish',
  },
  {
    id: 'dec-002',
    name: 'Table Centrepiece Set',
    category: 'Decor',
    price: 25,
    unit: 'per set/day',
    minQty: 10,
    image: 'https://readdy.ai/api/search-image?query=elegant%20gold%20table%20centrepiece%20with%20candle%20holder%20and%20floral%20arrangement%20on%20clean%20white%20background%2C%20premium%20event%20decor%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting&width=400&height=400&seq=hire-centre-001&orientation=squarish',
  },
  {
    id: 'acr-001',
    name: 'Acrylic Wine Glass',
    category: 'Acrylic Glassware',
    price: 1,
    unit: 'per glass/day',
    minQty: 1,
    maxQty: 400,
    promo: true,
    image: 'https://readdy.ai/api/search-image?query=clear%20acrylic%20wine%20glass%20shatterproof%20elegant%20stemware%20on%20clean%20white%20background%2C%20premium%20unbreakable%20event%20glassware%2C%20professional%20product%20photography%2C%20crystal%20clear%20plastic%20wine%20glass%20simple%20studio%20lighting&width=400&height=400&seq=hire-acr-001&orientation=squarish',
  },
  {
    id: 'acr-002',
    name: 'Acrylic Champagne Flute',
    category: 'Acrylic Glassware',
    price: 1,
    unit: 'per flute/day',
    minQty: 1,
    maxQty: 400,
    promo: true,
    image: 'https://readdy.ai/api/search-image?query=clear%20acrylic%20champagne%20flute%20shatterproof%20elegant%20stemware%20on%20clean%20white%20background%2C%20premium%20unbreakable%20sparkling%20wine%20glass%2C%20professional%20product%20photography%2C%20crystal%20clear%20plastic%20flute%20simple%20studio%20lighting&width=400&height=400&seq=hire-acr-002&orientation=squarish',
  },
  {
    id: 'acr-003',
    name: 'Acrylic Cocktail Coupe',
    category: 'Acrylic Glassware',
    price: 1,
    unit: 'per glass/day',
    minQty: 1,
    maxQty: 400,
    promo: true,
    image: 'https://readdy.ai/api/search-image?query=clear%20acrylic%20cocktail%20coupe%20glass%20shatterproof%20elegant%20on%20clean%20white%20background%2C%20premium%20unbreakable%20martini%20style%20glass%2C%20professional%20product%20photography%2C%20crystal%20clear%20plastic%20coupe%20simple%20studio%20lighting&width=400&height=400&seq=hire-acr-003&orientation=squarish',
  },
  {
    id: 'acr-004',
    name: 'Acrylic Tumbler Glass',
    category: 'Acrylic Glassware',
    price: 1,
    unit: 'per glass/day',
    minQty: 1,
    maxQty: 400,
    promo: true,
    image: 'https://readdy.ai/api/search-image?query=clear%20acrylic%20tumbler%20glass%20shatterproof%20rocks%20glass%20on%20clean%20white%20background%2C%20premium%20unbreakable%20whiskey%20glass%2C%20professional%20product%20photography%2C%20crystal%20clear%20plastic%20tumbler%20simple%20studio%20lighting&width=400&height=400&seq=hire-acr-004&orientation=squarish',
  },
  {
    id: 'acr-005',
    name: 'Acrylic Highball Glass',
    category: 'Acrylic Glassware',
    price: 1,
    unit: 'per glass/day',
    minQty: 1,
    maxQty: 400,
    promo: true,
    image: 'https://readdy.ai/api/search-image?query=clear%20acrylic%20highball%20glass%20tall%20shatterproof%20on%20clean%20white%20background%2C%20premium%20unbreakable%20collins%20glass%2C%20professional%20product%20photography%2C%20crystal%20clear%20plastic%20highball%20simple%20studio%20lighting&width=400&height=400&seq=hire-acr-005&orientation=squarish',
  },
  {
    id: 'con-001',
    name: 'Ice 5kg Bag',
    category: 'Consumables',
    price: 7,
    unit: 'per unit',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=five%20kilogram%20bag%20of%20premium%20ice%20cubes%20in%20clear%20plastic%20packaging%20on%20clean%20white%20background%2C%20crystal%20clear%20party%20ice%20for%20events%20and%20cocktails%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20cold%20refreshing%20look&width=400&height=400&seq=hire-con-001&orientation=squarish',
  },
  {
    id: 'stf-001',
    name: 'Senior Bar Staff (8hr Shift)',
    category: 'Staffing',
    price: 600,
    unit: 'per shift',
    minQty: 1,
    description: 'Experienced bartender with 5+ years in hospitality. Handles high-volume service, crafts classic cocktails, manages bar operations, trains junior staff, and ensures smooth beverage service throughout your event.',
    image: 'https://readdy.ai/api/search-image?query=professional%20senior%20bartender%20in%20elegant%20black%20uniform%20shaking%20cocktail%20shaker%20on%20clean%20white%20background%2C%20experienced%20mixologist%20event%20staff%2C%20premium%20bartending%20service%2C%20professional%20portrait%20photography%2C%20warm%20studio%20lighting%2C%20confident%20pose&width=400&height=400&seq=hire-stf-001&orientation=squarish',
  },
  {
    id: 'stf-002',
    name: 'Junior Bar Staff (8hr Shift)',
    category: 'Staffing',
    price: 350,
    unit: 'per shift',
    minQty: 1,
    description: 'Enthusiastic bartender with 1-2 years experience. Assists with drink preparation, serves beer and wine, restocks bar supplies, maintains cleanliness, and provides friendly customer service under supervision.',
    image: 'https://readdy.ai/api/search-image?query=young%20professional%20bartender%20in%20smart%20black%20polo%20shirt%20standing%20behind%20bar%20counter%20on%20clean%20white%20background%2C%20friendly%20junior%20bar%20staff%20for%20events%2C%20hospitality%20worker%20portrait%2C%20professional%20photography%2C%20warm%20studio%20lighting%2C%20approachable%20smile&width=400&height=400&seq=hire-stf-002&orientation=squarish',
  },
  {
    id: 'stf-003',
    name: 'Cocktail Mixologist (8hr Shift)',
    category: 'Staffing',
    price: 750,
    unit: 'per shift',
    minQty: 1,
    description: 'Expert mixologist specializing in craft cocktails and flair bartending. Creates signature drinks, performs cocktail demonstrations, uses premium techniques, engages guests with showmanship, and elevates your bar experience.',
    image: 'https://readdy.ai/api/search-image?query=expert%20cocktail%20mixologist%20pouring%20layered%20drink%20with%20flair%20on%20clean%20white%20background%2C%20premium%20craft%20cocktail%20bartender%20in%20black%20vest%20and%20bow%20tie%2C%20artistic%20drink%20preparation%2C%20professional%20portrait%20photography%2C%20warm%20golden%20studio%20lighting%2C%20skilled%20hands&width=400&height=400&seq=hire-stf-003&orientation=squarish',
  },
  {
    id: 'stf-004',
    name: 'Bar Manager / Supervisor (8hr Shift)',
    category: 'Staffing',
    price: 850,
    unit: 'per shift',
    minQty: 1,
    description: 'Seasoned bar manager with leadership expertise. Oversees entire bar operation, coordinates staff, manages inventory and cash handling, resolves issues, ensures RSA compliance, and delivers seamless service from setup to packdown.',
    image: 'https://readdy.ai/api/search-image?query=professional%20bar%20manager%20in%20formal%20black%20suit%20with%20clipboard%20supervising%20event%20bar%20setup%20on%20clean%20white%20background%2C%20experienced%20hospitality%20supervisor%2C%20leadership%20pose%2C%20professional%20portrait%20photography%2C%20warm%20studio%20lighting%2C%20confident%20authority&width=400&height=400&seq=hire-stf-004&orientation=squarish',
  },
  {
    id: 'stf-005',
    name: 'Waitstaff / Floor Staff (8hr Shift)',
    category: 'Staffing',
    price: 300,
    unit: 'per shift',
    minQty: 1,
    description: 'Professional waitstaff for roaming beverage service. Circulates with trays, serves drinks to guests, collects empty glasses, assists with catering needs, and ensures all attendees are looked after throughout the event.',
    image: 'https://readdy.ai/api/search-image?query=professional%20waiter%20in%20elegant%20black%20and%20white%20uniform%20carrying%20silver%20tray%20on%20clean%20white%20background%2C%20event%20waitstaff%20floor%20service%2C%20hospitality%20catering%20staff%2C%20professional%20portrait%20photography%2C%20warm%20studio%20lighting%2C%20graceful%20pose&width=400&height=400&seq=hire-stf-005&orientation=squarish',
  },
  {
    id: 'stf-006',
    name: 'Barista (Coffee Service, 5hr)',
    category: 'Staffing',
    price: 400,
    unit: 'per shift',
    minQty: 1,
    description: 'Skilled barista for premium coffee service. Operates espresso machines, creates latte art, serves specialty coffee drinks, manages coffee station setup, and provides a café-quality experience for morning or afternoon events.',
    image: 'https://readdy.ai/api/search-image?query=professional%20barista%20in%20black%20apron%20preparing%20latte%20art%20with%20espresso%20machine%20on%20clean%20white%20background%2C%20skilled%20coffee%20service%20specialist%20for%20events%2C%20artisan%20coffee%20maker%2C%20professional%20portrait%20photography%2C%20warm%20studio%20lighting%2C%20focused%20craftsmanship&width=400&height=400&seq=hire-stf-006&orientation=squarish',
  },
];
